export default "assets/images/logo-eldo-eae9ac32.png";